import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, ProgressBar, Spinner } from 'react-bootstrap';

import { get } from '../api2';

function getQueriesByEncryptionStatus(data, status) {
  const item = data.find((item) => item.encrypted === status);
  return item ? item.queries : 0;
}

export default function AnalyticsEncryptedDNS({ profile, device, timeRange }) {
  const { t, i18n } = useTranslation();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    return get(
      `/profiles/${profile}/analytics/encryption`,
      {
        device,
        ...timeRange,
      },
      ({ data }) => {
        setData(data);
        setLoading(false);
      }
    );
  }, [profile, device, timeRange]);

  return (
    <Card body className="mb-4">
      <h5>{t('analytics.encrypted.name')}</h5>
      <div style={{ opacity: 0.6, fontSize: '0.9em' }}>{t('analytics.encrypted.description')}</div>
      <div className="mt-3">
        {loading ? (
          <div className="text-center">
            <Spinner animated="border" style={{ width: '2rem', height: '2rem', opacity: 0.15 }} className="my-2" />
          </div>
        ) : data.length === 0 ? (
          <div className="text-center my-2" style={{ opacity: 0.4 }}>
            {t('analytics.encrypted.empty')}
          </div>
        ) : (
          <>
            <ProgressBar
              variant="success"
              now={Math.max(
                (getQueriesByEncryptionStatus(data, true) /
                  (getQueriesByEncryptionStatus(data, true) + getQueriesByEncryptionStatus(data, false))) *
                  100,
                0.5
              )}
            />
            <div className="text-success" style={{ fontSize: '0.9em', fontWeight: 500, marginTop: 4 }}>
              {i18n.format(
                getQueriesByEncryptionStatus(data, true) /
                  (getQueriesByEncryptionStatus(data, true) + getQueriesByEncryptionStatus(data, false)),
                'percentage'
              )}
            </div>
          </>
        )}
      </div>
    </Card>
  );
}
